import { render, staticRenderFns } from "./DownloadMultiple.vue?vue&type=template&id=63c2fc60&"
import script from "./DownloadMultiple.vue?vue&type=script&lang=js&"
export * from "./DownloadMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports